import React from 'react';
import { observer } from 'mobx-react';

import { Button, Dialog, Typography, FormControlLabel, Checkbox } from '@material-ui/core';

import '../../styles/PopUp.scss';

import appStore from '../../stores/AppStore';

const styles = {
  popupstyle: {
    width: '100%',
  },
  popupTitle: {
    width: '100%',
  },
  iconStyle: {
    alignSelf: 'center',
    marginRight: '10px',
  },
  panelStyle: {
    marginTop: '15px',
  },
};

const PopUp = observer(
  class PopupRetractoTotal extends React.Component {
    state = {
      retractoCredito: true,
      retractoCuenta: true,
      retractoTarjeta: true,
    };

    hide = () => {
      if (this.props.onClose) {
        this.props.onClose();
      }
    };

    doRetracto = () => {
      if (this.state.retractoCredito || this.state.retractoCuenta || this.state.retractoTarjeta) {
        appStore.ofertasStore.ejecutarRetracto(this.state.retractoCredito, this.state.retractoTarjeta, this.state.retractoCuenta, this.onEjecutarRetractoResult);
      }
    };

    onEjecutarRetractoResult = () => {
      if (this.props.onRetractoEjecutado) {
        this.props.onRetractoEjecutado();
      }
    };

    render() {
      let credito;
      let tarjeta;
      let cuenta;
      if (appStore.ofertasStore.oferta && appStore.ofertasStore.oferta.ofertaCredito && appStore.ofertasStore.oferta.ofertaCredito.selected) {
        const ofertaCredito = appStore.ofertasStore.oferta.ofertaCredito;
        credito = (
          <FormControlLabel
            value={this.state.retractoCredito}
            control={<Checkbox color="primary" checked={true}/>}
            label={ofertaCredito.nombreProducto}
            labelPlacement="start"
            className="checkRetracto"
            disabled={true}
          />
        );
      }
      if (appStore.ofertasStore.oferta && appStore.ofertasStore.oferta.ofertaTarjeta && appStore.ofertasStore.oferta.ofertaTarjeta.selected) {
        const ofertaTarjeta = appStore.ofertasStore.oferta.ofertaTarjeta;
        tarjeta = <FormControlLabel control={<Checkbox color="primary" disabled={true} checked={true}/>} label={ofertaTarjeta.nombreProducto} labelPlacement="start" className="checkRetracto" />;
      }
      if (appStore.ofertasStore.oferta && appStore.ofertasStore.oferta.ofertaCuenta && appStore.ofertasStore.oferta.ofertaCuenta.selected) {
        const ofertaCuenta = appStore.ofertasStore.oferta.ofertaCuenta;
        cuenta = <FormControlLabel control={<Checkbox color="primary" disabled={true} checked={true}/>} label={ofertaCuenta.nombreProducto} labelPlacement="start" className="checkRetracto" />;
      }

      return (
        <Dialog id="modal" modal="true" open={this.props.open} style={styles.popupstyle}>
          <div className="Panel" style={styles.panelStyle}>
            <div className="titlePopup">
              <div id="txtTituloModal" style={styles.popupTitle}>

              </div>
            </div>
            <div className="boxMensaje">
              <div className="mensaje">
                <Typography className="textoRetracto colorMorado">Te arrepentirás de los siguientes productos</Typography>
                <div className="opcionesRetracto">
                  {credito}
                  {tarjeta}
                  {cuenta}
                </div>
              </div>
              <div className="boxButton">
                <Button id="btnPopUpCerrar" variant="contained" color="primary" onClick={this.hide} className="btnRipleyAmarillo" fullWidth={true}>
                  cerrar
                </Button>
                <Button
                  id="btnPopUp"
                  variant="contained"
                  color="primary"
                  onClick={this.doRetracto}
                  className="btn-moradoModal"
                  fullWidth={true}
                  disabled={!(this.state.retractoCredito || this.state.retractoCuenta || this.state.retractoTarjeta)}
                >
                  aceptar
                </Button>
              </div>
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }
);

//const PopUp = withStyles(styles)(PopUpMandatoComponent);

export default PopUp;
